import { priceBookIdFormat } from "@redotech/redo-model/ids";
import { PriceBookDetailRowSchema } from "@redotech/redo-model/price-book/price-book";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getPriceBook = unaryRpc({
  name: "getPriceBook" as const,
  input: z.object({ priceBookId: priceBookIdFormat.schema }),
  output: z.object({ priceBook: PriceBookDetailRowSchema.nullable() }),
});
